module.exports = __webpack_public_path__ + "img/IntegralLockRight.a288c860.png";